"use client";

import { lazy, Suspense, useCallback, useState } from "react";

const SplatPortrait = lazy(() =>
  import("../../app/SplatPortrait").then((module) => ({ default: module.SplatPortrait })),
);

const POSTER_URL = "/images/responsive/david-spz-poster-960.webp";

export function DeferredSplatPortrait() {
  const [shouldLoadRenderer, setShouldLoadRenderer] = useState(false);
  const requestRenderer = useCallback(() => setShouldLoadRenderer(true), []);

  return (
    <>
      {/* Keep the hero legible while the optional interactive layer arrives. */}
      <button
        aria-label="Activate interactive 3D portrait of David Paul Romero"
        className="splat-activation"
        onClick={requestRenderer}
        onFocus={requestRenderer}
        onPointerDown={requestRenderer}
        onPointerEnter={requestRenderer}
        type="button"
      >
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          alt=""
          className="splat-poster"
          decoding="async"
          fetchPriority="high"
          height="1178"
          sizes="(max-width: 719px) 50vw, 40vw"
          src={POSTER_URL}
          srcSet="/images/responsive/david-spz-poster-480.webp 480w, /images/responsive/david-spz-poster-960.webp 960w"
          width="942"
        />
      </button>
      {shouldLoadRenderer ? (
        <Suspense fallback={null}>
          <SplatPortrait showPoster={false} />
        </Suspense>
      ) : null}
    </>
  );
}
